import { usePathname, useSearchParams } from 'next/navigation';

/**
 * Builds the current path + query string for use as a `signIn` callbackUrl,
 * so the user is returned to the exact search they were viewing after auth.
 */
export function useCallbackUrl(): string {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const query = searchParams?.toString();
  return query ? `${pathname}?${query}` : pathname;
}
